import React, {FC}              from 'react';
import {HBox}                   from '@sirius/ui-lib/src/blocks/Layout';
import {SchemaFieldProps}       from '@sirius/ui-lib/src/blocks/SchemaField/@types';
import { Marked }               from '@sirius/ui-shared/src/components/DisplayEngine';


export const MDField: FC<SchemaFieldProps> = (props) => {
    const {
        block,
        schema,
        className = '',
    } = props;
    const {title: mdSource} = schema;

    return (
        <HBox className={block.el('markdown') + className}>
            <Marked>{mdSource}</Marked>
        </HBox>
    )
}
